// extracted by mini-css-extract-plugin
export default {"feedbackSection":"FeedbackSection_feedbackSection__y2yHk","containerLeft":"FeedbackSection_containerLeft__hyP8l"};